// Single source of truth for the app version.
// Bump this one line when you cut a new version; it updates everywhere.
export const APP_VERSION = '1.3';
